import { REFERRAL_CHANNEL_LABELS, type VoucherChannelClicks } from '@/marketing/models/voucher';

export interface VoucherChannelClickRow {
  key: string;
  label: string;
  clicks: number;
  /** Whole-number share of all clicks; 0 when there are no clicks at all. */
  sharePercent: number;
}

export interface VoucherChannelClicksInput {
  clicks: number;
  clicksByChannel: VoucherChannelClicks[];
  untaggedClicks: number;
}

const UNTAGGED_KEY = 'untagged';
const PERCENT = 100;

/**
 * The sheet lists the six channels in the order the API sends them, then an Untagged row for links copied
 * without a channel, so a creator who never used channel links still reads as one row rather than nothing.
 */
export function buildVoucherChannelClickRows({
  clicks,
  clicksByChannel,
  untaggedClicks,
}: VoucherChannelClicksInput): VoucherChannelClickRow[] {
  const shareOf = (count: number): number => (clicks > 0 ? Math.round((count / clicks) * PERCENT) : 0);
  const channelRows = clicksByChannel.map((channelClicks) => ({
    key: channelClicks.channel,
    label: REFERRAL_CHANNEL_LABELS[channelClicks.channel] ?? channelClicks.channel,
    clicks: channelClicks.clicks,
    sharePercent: shareOf(channelClicks.clicks),
  }));

  return [
    ...channelRows,
    { key: UNTAGGED_KEY, label: 'Untagged', clicks: untaggedClicks, sharePercent: shareOf(untaggedClicks) },
  ];
}
